import * as types from './mutation-types.js'
import api from '@/services/api'
import { getDeepProperty } from '@/helpers/deepObject.js'
import upload from '@/services/api/upload.js'

const state = {
  promo: null,
  promos: null
}

const actions = {
  clearPromo ({commit}) {
    commit(types.CLEAR_PROMO)
  },
  clearPromos ({ commit }) {
    commit(types.CLEAR_PROMOS)
  },
  async getPromo ({ commit, state }) {
    const promos = getDeepProperty(state, 'promos.collection')
    if (!promos || promos.length === 0) {
      commit(types.CLEAR_PROMO)
      return {}
    }
    const path = getDeepProperty(promos[0], 'ad.href')
    let promo = await api.get(path).then(({data}) => {
      return data
    })
    commit(types.SET_PROMO, promo)
    return promo
  },
  async getPromos ({ commit }, path) {
    let promos = await api.get(path).then(async ({data}) => {
      return data
    })
    commit(types.SET_PROMOS, promos)
  },
  async updatePromos ({ commit, state }, payload) {
    let promos = await api.post(state.promos.href, payload).then(async ({data}) => {
      return data
    })
    commit(types.SET_PROMOS, promos)
  },
  async createPromo ({ commit, state}, {promoAudio, progressCallback}) {
    let payload = {
      type: 'pre',
      file_name: promoAudio.name
    }
    let ad = await api.post(state.promos.create.action, payload)
      .then(async ({data}) => data)
    let headers = {'Content-Disposition': `filename="${promoAudio.name}"`}
    await upload.uploadAudio(ad.signed_url, promoAudio, headers, progressCallback)
    // association doesn't seem to happen with the "type: pre, so doing associate here for now"
    let promos = await api.post(ad.associate.action, { position: 'pre' })
      .then(async ({data}) => data)
    commit(types.SET_PROMOS, promos)
    return actions.getPromo({ commit, state })
  },
  async deletePromo ({ commit, state }) {
    api.delete(state.promo.delete.action)
      .then(async data => {
        return data
      })
      .catch(err => {
        return err
      })
    commit(types.CLEAR_PROMO)
  }
}

const mutations = {
  [types.CLEAR_PROMO] (state) {
    state.promo = null
  },
  [types.CLEAR_PROMOS] (state) {
    state.promos = null
  },
  [types.SET_PROMO] (state, promo) {
    state.promo = promo
  },
  [types.SET_PROMOS] (state, promos) {
    state.promos = promos
  }
}

const getters = {
  promo: state => state.promo,
  promos: state => state.promos
}

export default {
  state,
  actions,
  mutations,
  getters
}
